import { UserUpdateDto } from 'src/app/services/generatedApi';

export const userInitialValues: UserUpdateDto = {
  firstName: '',
  lastName: '',
  nationalCode: '',
  birthDate: '',
  gender: 'MALE',
};
